import BlogCover from '@/components/BlogCover';

import coverImage from './images/cover.png';
import profileImage from './images/profile.png';

const Component: React.FC = () => (
  <BlogCover
    title="平岡義博ブログ"
    coverImage={coverImage}
    profileImage={profileImage}
    description="ジュニア、トップ選手、強豪校を指導"
  />
);

export default Component;
